import { createApp } from 'vue' // 引入Vue
import App from './App.vue' // 引入根组件
import router from './router' // 引入路由
import vuetify from './plugins/vuetify' // 引入vuetify插件
import i18n from './plugins/i18n' // 引入国际化插件
import { loadFonts } from './plugins/webfontloader' // 加载字体文件
import './styles/global.css' // 引入全局样式文件

loadFonts()

createApp(App)
  .use(router)
  .use(vuetify)
  .use(i18n)
  .mount('#app')
